import { call, put, all, takeEvery, take } from 'redux-saga/effects';
import { gcApi } from 'config/axios';
import {
    FETCH_USER_PRIVACY,
    FETCH_USER_PRIVACY_START,
    FETCH_USER_PRIVACY_SUCCESS,
    FETCH_USER_PRIVACY_ERROR,
    SAVE_UPDATED_USER_PRIVACY,
    SET_USER_PRIVACY_START,
    SET_USER_PRIVACY_SUCCESS,
    SET_USER_PRIVACY_ERROR,
    FETCH_BULK_PRIVACY,
    FETCH_BULK_PRIVACY_START,
    FETCH_BULK_PRIVACY_SUCCESS,
    FETCH_BULK_PRIVACY_ERROR,
    SAVE_BULK_PRIVACY,
    SET_BULK_PRIVACY_ERROR,
    SET_BULK_PRIVACY_SUCCESS,
    SET_BULK_PRIVACY_START
} from '../../actions/ActionTypes';
import { handlingErrorCallback, handlingSuccessCallback } from 'sagas/sagasUtils';

// worker
export function* fetchUserPrivacy() {
    try {
        yield put({
            type: FETCH_USER_PRIVACY_START
        });

        const response = yield call(gcApi.get, '/privacysettings-service/privacy-settings');

        yield put({
            type: FETCH_USER_PRIVACY_SUCCESS,
            data: response && response.data ? response.data : {}
        });
    } catch (e) {
        yield put({
            type: FETCH_USER_PRIVACY_ERROR
        });
    }
}

export function* setPrivacy(action) {
    try {
        yield put({
            type: SET_USER_PRIVACY_START
        });

        if (action && action.data) {
            yield call(gcApi.put, '/privacysettings-service/privacy-settings', {
                ...action.data
            });

            handlingSuccessCallback(action.callback, {});

            //api does not return the data after put - so we use the payload since it should be the same with no changes - within receivedUserPrivacy it uses action.data
            yield put({
                type: SET_USER_PRIVACY_SUCCESS,
                data: action.data
            });
        }
    } catch (e) {
        handlingErrorCallback(action.callback, e);
        yield put({
            type: SET_USER_PRIVACY_ERROR
        });
    }
}

// worker
export function* fetchBulkPrivacy(action) {
    try {
        yield put({
            type: FETCH_BULK_PRIVACY_START
        });

        const response = yield call(gcApi.get, '/activity-service/activity/privacy/bulk');

        handlingSuccessCallback(action.callback, response);

        yield put({
            type: FETCH_BULK_PRIVACY_SUCCESS,
            data: response && response.data ? response.data : {}
        });
    } catch (e) {
        handlingErrorCallback(action.callback, e);
        yield put({
            type: FETCH_BULK_PRIVACY_ERROR
        });
    }
}

export function* setBulkPrivacy(action) {
    try {
        yield put({
            type: SET_BULK_PRIVACY_START
        });

        if (action && action.data) {
            yield call(gcApi.post, '/activity-service/activity/privacy/bulk', {
                ...action.data
            });

            //api does not return the data after put - so we use the payload since it should be the same with no changes - within receivedUserPrivacy it uses action.data
            yield put({
                type: SET_BULK_PRIVACY_SUCCESS,
                data: action
            });
        }
    } catch (e) {
        yield put({
            type: SET_BULK_PRIVACY_ERROR
        });
    }
}

// watcher
export const userPrivacySagas = [
    takeEvery(FETCH_USER_PRIVACY, fetchUserPrivacy),
    takeEvery(SAVE_UPDATED_USER_PRIVACY, setPrivacy),
    takeEvery(FETCH_BULK_PRIVACY, fetchBulkPrivacy),
    takeEvery(SAVE_BULK_PRIVACY, setBulkPrivacy)
];
